export const TRIGGER_PREFIX_ABOVE = ">";
export const TRIGGER_PREFIX_BELOW = "<";
export const GITBOOK_URL = 'https://mirakle.gitbook.io/'